import { render } from "./AssoListView.vue?vue&type=template&id=1ef66de2&scoped=true"
import script from "./AssoListView.vue?vue&type=script&lang=js"
export * from "./AssoListView.vue?vue&type=script&lang=js"

import "./AssoListView.vue?vue&type=style&index=0&id=1ef66de2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef66de2"]])

export default __exports__